<template>
  <div class="layout" :class="languages">
    <Layout>
      <vHeader @collapsedSider="collapsedSider" :isCollapsed="isCollapsed" @updateMenu="updateMenu"></vHeader>
      <Layout class="main_container">
        <Sider ref="sider_box" hide-trigger collapsible :collapsed-width="0" :width="240" class="sider_container" v-model="isCollapsed">
          <v-left ref="leftComponent" :isCollapsed="isCollapsed" :key="keyTalg"></v-left>
        </Sider>
        <Layout class="content_container">
          <breadcrumb ref="breadcrumbBox"></breadcrumb>
          <!-- 如果当前打开页面的路由中 keepAlive: true （开启了缓存时） -->
          <keep-alive max="1">
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <!-- 如果当前打开页面的路由中 没有 或者为 keepAlive: false （关闭缓存时[默认就是false]） -->
          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </Layout>
      </Layout>
    </Layout>
    <!--系统公告弹窗-->
    <viewAnnouncementModal :isRegisterTimeAfter="1" :whetherInitial="false"></viewAnnouncementModal>
    <!--消息通知弹窗-->
    <messageNotificationModal></messageNotificationModal>
    <!--商品驳回通知弹窗-->
    <productRejectionNoticeModal v-if="system === 'supplier'"></productRejectionNoticeModal>
    <!--创建备货单包含定制商品的异常提示-->
    <abnormalStockingOfGoodsModal></abnormalStockingOfGoodsModal>
    <!--账单更新完成提示-->
    <billUpdateCompletedModal></billUpdateCompletedModal>
    <!--返回顶部按钮-->
    <AppBackTop :bottom="60"></AppBackTop>
  </div>
</template>
<style lang="less" scoped>

</style>
<script>
import vHeader from './header';
import vLeft from './left';
import breadcrumb from './menu/breadcrumb';
import Mixin from '@/components/mixin/common_mixin';
import viewAnnouncementModal from "@/components/common/viewAnnouncementModal.vue";
import messageNotificationModal from "@/components/common/messageNotificationModal";
import {addLangStyle, getSetLanguages} from '@/utils/common';
import productRejectionNoticeModal from "@/components/common/productRejectionNoticeModal";
import abnormalStockingOfGoodsModal from "@/components/common/abnormalStockingOfGoodsModal.vue";
import billUpdateCompletedModal from "@/components/common/billUpdateCompletedModal.vue";
import {bindAppScrollClosePoppers, unbindAppScrollClosePoppers} from "@/utils/bindAppScrollClosePoppers";
import AppBackTop from "@/components/common/AppBackTop.vue";

export default {
  mixins: [Mixin],
  components: {
    productRejectionNoticeModal,
    vHeader,
    vLeft,
    breadcrumb,
    viewAnnouncementModal,
    messageNotificationModal,
    abnormalStockingOfGoodsModal,
    billUpdateCompletedModal,
    AppBackTop
  },
  data() {
    return {
      isCollapsed: false,
      keyTalg: new Date().getTime(),
      languages: '',
    };
  },
  mounted() {
    this.$nextTick(() => {
      bindAppScrollClosePoppers({
        selector: '#app',
        useRaf: true
      });
    });
  },
  beforeDestroy() {
    unbindAppScrollClosePoppers();
  },
  methods: {
    collapsedSider(isCollapsed) {
      this.isCollapsed = isCollapsed;
    },
    updateMenu(key) {
      this.keyTalg = key;
    },
  },
  watch: {
    $route(to, from) {
      this.getPageSizeStorage();
    }
  },
  created() {
    this.$webSocket.initWebSocket();
    this.languages = getSetLanguages();
    addLangStyle();
  }
};
</script>
<style>

</style>
